const FollowTag = () => import('@/pages/tag-manage/FollowTag');
const QuickInputTag = () => import('@/pages/tag-manage/QuickInputTag');
const CancelInputTag = () => import('@/pages/tag-manage/CancelInputTag');

export default [{
		path: '/follow-tag',
		component: FollowTag,
		meta: [{
				name: '标签管理',
				url: '/follow-tag',
			},
			{
				name: '进度标签设置',
				url: '',
			},
		],
	},
	{
		path: '/quick-input-tag',
		component: QuickInputTag,
		meta: [{
				name: '标签管理',
				url: '/follow-tag',
			},
			{
				name: '快捷输入标签设置',
				url: '',
			},
		],
	},
	{
		path: '/cancel-input-tag',
		component: CancelInputTag,
		meta: [{
				name: '标签管理',
				url: '/cancel-input-tag',
			},
			{
				name: '撤回标签设置',
				url: '',
			},
		],
	}
]
